import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';

const TawkChatButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    // Additional check to hide Tawk.to default widget
    const hideDefaultTawk = () => {
      if (window.Tawk_API && window.Tawk_API.hideWidget) {
        window.Tawk_API.hideWidget();
      }
    };
    
    // Try to hide on component mount
    hideDefaultTawk();
    
    // Try again after a delay in case Tawk loads later
    const timer = setTimeout(hideDefaultTawk, 2000);
    
    return () => clearTimeout(timer);
  }, []);

  const openTawkChat = () => {
    // Check if Tawk_API is loaded
    if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
      window.Tawk_API.maximize();
    } else {
      // Fallback to contact page if Tawk.to hasn't loaded
      window.location.href = '/contact';
    }
  };

  return (
    <button
      onClick={openTawkChat}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-6 right-6 group"
      style={{
        zIndex: 99999, // Extremely high to be above everything
        background: 'linear-gradient(135deg, #D4A74A 0%, #C69A3E 100%)',
        padding: '20px',
        borderRadius: '50%',
        border: '3px solid #000A22',
        boxShadow: isHovered 
          ? '0 20px 40px rgba(212, 167, 74, 0.6), 0 0 0 6px rgba(212, 167, 74, 0.2)'
          : '0 10px 30px rgba(0, 10, 34, 0.4)',
        transform: isHovered ? 'scale(1.15) translateY(-5px)' : 'scale(1)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: 'pointer',
        animation: 'pulse-gold 2s infinite'
      }}
      aria-label="Chat with Pattaya Solicitors"
    >
      <MessageCircle 
        className="w-8 h-8" 
        style={{ 
          color: '#000A22',
          strokeWidth: 2.5,
          filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
        }} 
      />
      
      {/* Tooltip */}
      <div
        style={{
          position: 'absolute',
          bottom: '100%',
          right: '0',
          marginBottom: '16px',
          background: 'linear-gradient(135deg, #000A22 0%, #001438 100%)',
          color: 'white',
          padding: '14px 24px',
          borderRadius: '14px',
          whiteSpace: 'nowrap',
          fontSize: '15px',
          fontWeight: '600',
          boxShadow: '0 10px 30px rgba(0, 10, 34, 0.4)',
          opacity: isHovered ? 1 : 0,
          transform: isHovered ? 'translateY(0)' : 'translateY(8px)',
          transition: 'all 0.3s ease',
          pointerEvents: 'none',
          border: '2px solid #D4A74A',
          zIndex: 100000
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div 
            style={{
              width: '10px',
              height: '10px',
              background: '#22c55e',
              borderRadius: '50%',
              animation: 'pulse-green 1.5s infinite',
              boxShadow: '0 0 8px rgba(34, 197, 94, 0.6)'
            }}
          />
          <span>Chat with us now</span>
        </div>
        {/* Arrow */}
        <div
          style={{
            position: 'absolute',
            top: '100%',
            right: '24px',
            width: '0',
            height: '0',
            borderLeft: '10px solid transparent',
            borderRight: '10px solid transparent',
            borderTop: '10px solid #D4A74A'
          }}
        />
      </div>

      {/* Pulsing ring animation */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          border: '3px solid #D4A74A',
          opacity: isHovered ? 0 : 0.7,
          animation: 'ping-gold 2s cubic-bezier(0, 0, 0.2, 1) infinite',
          pointerEvents: 'none'
        }}
      />

      <style jsx>{`
        @keyframes pulse-gold {
          0%, 100% {
            box-shadow: 0 10px 30px rgba(0, 10, 34, 0.4), 0 0 0 0 rgba(212, 167, 74, 0.5);
          }
          50% {
            box-shadow: 0 10px 30px rgba(0, 10, 34, 0.4), 0 0 0 12px rgba(212, 167, 74, 0);
          }
        }

        @keyframes ping-gold {
          0% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 0.7;
          }
          100% {
            transform: translate(-50%, -50%) scale(1.6);
            opacity: 0;
          }
        }

        @keyframes pulse-green {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.6;
            transform: scale(1.1);
          }
        }
      `}</style>
    </button>
  );
};

export default TawkChatButton;
